"use client";

import React from "react";
import Image from "next/image";
import {Container} from "@/shared/components/shared/container";
import Link from "next/link";

export const Footer: React.FC = () => {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <footer className={'bg-custom-dark-gray'}>
            <Container className={'pt-8 lg:pt-14 pb-8 lg:pb-16 flex flex-col'}>
                <h4 className={'text-custom-w text-xs lg:text-2xl text-center'}>
                    &copy; 2025 Специализированный автосервис АвтоГарантСити. Все права защищены.
                </h4>
                <div className={'flex justify-center items-center align-center mt-4 lg:mt-14'}>
                    <Image
                        src={'/images/footer/profi-team.svg'}
                        alt="Профи тим"
                        width={148}
                        height={148}
                        className={'w-[63px] h-[63px] lg:w-[148px] lg:h-[148px]'}
                    />
                    <Image
                        src={'/images/footer/auto-priority.svg'}
                        alt="Авто Приорити"
                        width={148}
                        height={148}
                        className={'ml-5 lg:ml-11 w-[63px] h-[63px] lg:w-[148px] lg:h-[148px]'}
                    />
                    <Image
                        src={'/images/footer/work-love.svg'}
                        alt="Сделано с любовью"
                        width={148}
                        height={148}
                        className={'ml-5 lg:ml-11 w-[63px] h-[63px] lg:w-[148px] lg:h-[148px]'}
                    />
                </div>
                <button onClick={scrollToTop}
                        className="hover:white-70 transition-opacity duration-200 focus:outline-none rounded cursor-pointer self-center mt-6 lg:mt-13"
                        aria-label="Наверх"
                >
                    <svg
                        className={'w-[12px] h-[7px] lg:w-[29px] lg:h-[18px]'}
                        width="29"
                        height="18"
                        viewBox="0 0 29 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M14.513 0.796268L0.367188 14.9421L2.90165 17.4766L14.513 5.80625L26.1244 17.4176L28.6589 14.8832L14.513 0.796268Z"
                            fill="#696969"
                        />
                    </svg>
                </button>
                <a href={'/privacy-policy.pdf'}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={'text-custom-orange text-[11px] lg:text-2xl self-center mt-3 lg:mt-7'}
                >
                    Политика конфиденциальности
                </a>
                <p className={'text-[11px] lg:text-base text-custom-w text-center mt-4 lg:mt-11'}>
                    Вся представленная на сайте информация стоимости
                    сервисного обслуживания носит исключительно<br/>
                    информационный характер и не является публичной офертой,
                    определяемой положениями ст. 437 (2) ГК РФ
                </p>
            </Container>
        </footer>
    );
}